import { Card, Grid, TextInput, Text } from '@mantine/core';
import AdjustableTextArea from '../GeneratedContent/AdjustableTextArea';
import InitialMessagesEditor from './InitialMessagesEditor';

const PersonalizationTab = ({ chatBot, handleChange, domainLocale }) => {
  return (
    <Card withBorder mt="sm">
      <Grid mb="md">
        <Grid.Col span={{ base: 12, sm: 4 }} style={{ display: 'flex', alignItems: 'center' }}>
          <label>Welcome Messages</label>
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 8 }}>
          <InitialMessagesEditor
            value={chatBot.initialMessages}
            onChange={(value) => handleChange({ target: { name: 'initialMessages', value } })}
            domainLocale={domainLocale}
            withTagBuilder
            productFeeds={chatBot.productFeeds || []}
            agentUi={chatBot.agentUi}
          />
          <Text size="xs" c="dimmed" mt={4}>
            Shown to visitors when they open the chat. The domain language message is used first; Default / Fallback is used for anything else. Added questions appear as quick-reply buttons, product feeds as a carousel.
          </Text>
        </Grid.Col>
      </Grid>

      <Grid mb="md">
        <Grid.Col span={{ base: 12, sm: 4 }} style={{ display: 'flex', alignItems: 'center' }}>
          <label>Fallback Message</label>
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 8 }}>
          <AdjustableTextArea
            id="supportMessage"
            name="supportMessage"
            value={chatBot.supportMessage || ''}
            onChange={(e) => handleChange({ target: { name: 'supportMessage', value: e.target.value } })}
          />
          <Text size="xs" c="dimmed" mt={4}>
            Shown when the assistant can't confidently answer the request.
          </Text>
        </Grid.Col>
      </Grid>

      <Grid mb="md">
        <Grid.Col span={{ base: 12, sm: 4 }} style={{ display: 'flex', alignItems: 'center' }}>
          <label>Support Email</label>
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 8 }}>
          <TextInput
            name="supportEmail"
            placeholder="support@shop.com"
            value={chatBot.supportEmail || ''}
            onChange={(event) => handleChange(event)}
          />
          <Text size="xs" c="dimmed" mt={4}>
            Email shown when clients need additional support.
          </Text>
        </Grid.Col>
      </Grid>
    </Card>
  );
};

export default PersonalizationTab;
